import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from 'react';
import { createRoot } from 'react-dom/client';
import './initializeSDKs';
import App from './App';
import './index.scss';
const container = document.getElementById('root');
const root = createRoot(container);
root.render(_jsx(App, {}));
